/* eslint-disable global-require */
export default {
  default: require('./default').default,
  IdTypeInPersonVoting: require('./IdTypeInPersonVoting').default,
  VBMRules: require('./VBMRules').default,
  PreRegistration: require('./PreRegistration').default,
};
